import type { TsTypeType } from '../../types.js'
import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('ContentAreaBlock')
export class ContentAreaBlock extends Block {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'input',
		order: 1,
		label: 'Name',
		contentType: 'text',
		elementType: 'input',
		isMandatory: () => true,
	})
	name: TsTypeType = 'content'

	constructor(init: Partial<ContentAreaBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorTitle() {
		return `${super.getEditorTitle()} ${this.name}`
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#78909c'
	}

	getTitleColor(): string {
		return 'white'
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}

	public getOwnVariables(
		includeDeclarationVariables: boolean,
	): Record<string, string | null> {
		return this.parent?.getOwnVariablesForChildContentArea(this) ?? {}
	}
}
